import { Center as s } from "@bedrock-layout/center";
import { getSizeValue as d, sizes as n, checkIsCSSLength as a } from "@bedrock-layout/spacing-constants";
import m from "react";
import c from "styled-components";
const p = c.div.attrs(
  ({ theme: t, boundarySize: e, children: o }) => {
    var i;
    const r = typeof e == "number" && e > 0 ? `${e}px` : (i = d(t, e)) != null ? i : e;
    return {
      "data-bedrock-appboundary": "",
      children: /* @__PURE__ */ m.createElement(s, {
        maxWidth: r != null ? r : n.xxlarge
      }, o)
    };
  }
)`
  padding: 0;
  max-inline-size: 100%;
  overflow: hidden;
  height: 100%;
`;
p.displayName = "AppBoundary";
function l({ boundarySize: t }, e) {
  if (t === void 0)
    return;
  typeof t == "number" || a(t) || Object.keys(n).includes(t) || console.error(
    `${e} needs to be an number, CSSLength or SizesOptions`
  );
}
p.propTypes = {
  boundarySize: l
};
export {
  p as AppBoundary
};
